import React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/component/ds/utils';

/* "Separator" in Figma: 1px line, with three spacing steps. */
const separatorVariants = cva('ds-shrink-0 ds-bg-border', {
  variants: {
    orientation: {
      horizontal: 'ds-h-px ds-w-full',
      vertical: 'ds-w-px ds-h-full'
    },
    spacing: {
      none: '',
      regular: '',
      spacious: ''
    }
  },
  compoundVariants: [
    { orientation: 'horizontal', spacing: 'regular', class: 'ds-my-1' },
    { orientation: 'horizontal', spacing: 'spacious', class: 'ds-my-2' },
    { orientation: 'vertical', spacing: 'regular', class: 'ds-mx-1' },
    { orientation: 'vertical', spacing: 'spacious', class: 'ds-mx-2' }
  ],
  defaultVariants: { orientation: 'horizontal', spacing: 'none' }
});

export interface SeparatorProps
  extends Omit<React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>, 'orientation'>,
  VariantProps<typeof separatorVariants> {}

const Separator = React.forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, SeparatorProps>(
  ({ className, orientation = 'horizontal', spacing, decorative = true, ...props }, ref) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation ?? 'horizontal'}
      className={cn(separatorVariants({ orientation, spacing }), className)}
      {...props}
    />
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator, separatorVariants };
